import { PARENT_SUBTYPE_LABELS, PARTNER_SUBTYPE_LABELS } from './constants.js';
/** „Anna Maria Schmidt geb. Weber“ */
export function personDisplayName(p) {
    const parts = [p.givenNames?.trim(), p.surname?.trim()].filter(Boolean);
    const base = parts.join(' ') || 'Unbenannt';
    if (p.birthSurname && p.birthSurname.trim() && p.birthSurname.trim() !== p.surname?.trim()) {
        return `${base} geb. ${p.birthSurname.trim()}`;
    }
    return base;
}
export function initials(name) {
    const words = name.replace(/geb\..*$/i, '').trim().split(/\s+/).filter(Boolean);
    if (words.length === 0)
        return '?';
    if (words.length === 1)
        return (words[0] ?? '?').slice(0, 2).toUpperCase();
    return `${(words[0] ?? '')[0] ?? ''}${(words[words.length - 1] ?? '')[0] ?? ''}`.toUpperCase();
}
/** Rollenbezeichnung einer Beziehung aus Sicht der jeweiligen Person. */
export function parentRoleLabel(sex) {
    return sex === 'female' ? 'Mutter' : sex === 'male' ? 'Vater' : 'Elternteil';
}
export function childRoleLabel(sex) {
    return sex === 'female' ? 'Tochter' : sex === 'male' ? 'Sohn' : 'Kind';
}
export function siblingRoleLabel(sex, half) {
    const base = sex === 'female' ? 'Schwester' : sex === 'male' ? 'Bruder' : 'Geschwister';
    return half ? `Halb${base.toLowerCase()}` : base;
}
export function partnerRoleLabel(sex, subtype) {
    if (subtype === 'married')
        return sex === 'female' ? 'Ehefrau' : sex === 'male' ? 'Ehemann' : 'Ehepartner';
    if (subtype === 'divorced')
        return sex === 'female' ? 'Ex-Frau' : sex === 'male' ? 'Ex-Mann' : 'Ex-Partner';
    return sex === 'female' ? 'Partnerin' : 'Partner';
}
export function relationshipSubtypeLabel(kind, subtype) {
    if (!subtype)
        return kind === 'parent' ? 'Eltern–Kind' : 'Partnerschaft';
    const table = kind === 'parent' ? PARENT_SUBTYPE_LABELS : PARTNER_SUBTYPE_LABELS;
    return table[subtype] ?? subtype;
}
export function formatBytes(bytes) {
    if (!Number.isFinite(bytes) || bytes <= 0)
        return '0 B';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / 1024 ** i;
    return `${value < 10 && i > 0 ? value.toFixed(1) : Math.round(value)} ${units[i]}`;
}
export function sortPersonsByBirth(a, b) {
    const ay = a.birthYear ?? Number.POSITIVE_INFINITY;
    const by = b.birthYear ?? Number.POSITIVE_INFINITY;
    if (ay !== by)
        return ay - by;
    return a.displayName.localeCompare(b.displayName, 'de');
}
/**
 * Wann eine Partnerschaft durch den Tod endete – abgeleitet, nicht gespeichert.
 *
 * In den Daten bleibt `end` leer, und das ist richtig: „Ende“ ist die
 * Scheidung oder das, was jemand ausdrücklich eingetragen hat. Eine Ehe endet
 * aber faktisch mit dem ersten Tod, und dieser Umstand fehlt sonst überall in
 * der Anzeige. Deshalb wird er nur berechnet – wer das Sterbejahr korrigiert,
 * korrigiert damit auch diesen Hinweis, ohne eine zweite Stelle zu pflegen.
 *
 * Gibt das Jahr des *ersten* Todes der beiden zurück, oder null, wenn der
 * Hinweis nichts beiträgt: bei ausdrücklich eingetragenem Ende, bei einer
 * Scheidung (die endete vorher), wenn niemand gestorben ist – und wenn das
 * Sterbejahr vor dem Beginn liegt. Letzteres ist ein Datenfehler; ihn als
 * „verwitwet“ auszugeben würde ihn kaschieren.
 */
export function widowedSinceYear(input) {
    if (input.hasEnd)
        return null;
    if (input.subtype === 'divorced')
        return null;
    const years = [input.deathYearA, input.deathYearB].filter((year) => typeof year === 'number');
    if (years.length === 0)
        return null;
    const year = Math.min(...years);
    if (typeof input.startYear === 'number' && year < input.startYear)
        return null;
    return year;
}
/** „verwitwet seit 1990“ – eine Formulierung, überall dieselbe. */
export function widowedLabel(year) {
    return `verwitwet seit ${year}`;
}
//# sourceMappingURL=display.js.map